

import { useState, useEffect } from 'react';
import { Modal, Button,  Row, Col } from 'react-bootstrap';
import { deleteTransaction } from '../../utils/api';
import Loader from '../Loader';
import Error from '../Error';
import Success from '../Success';

const ArchiveTransactionModal = ({ show, onHide, transaction }) => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isSaved, setIsSaved] = useState(false);

    const resetState = () => {
        setError(null);
        setLoading(false);
    };

    useEffect(() => {
        const onLoad = () => {
            if (!show)
                resetState();
        }
        onLoad();
    }, [show]);

    const archiveClicked = async () => {
        setLoading(true);
        setError(null);
        const data = await deleteTransaction(transaction?.Id);
        if (data) {
            setIsSaved(true);
        }
        else {
            setError('Failed to archive');
        }

        if (data)
            setTimeout(() => onHide(true), 2000);

        setLoading(false);
    };

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" style={{ zIndex: 1050 }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Archive Confirmation</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ padding: 10 }}>
                        {loading ? <Loader /> : error ? <Error /> : isSaved ? (
                            <div style={{ height: 230, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Success />
                            </div>
                        ) : (
                            <>
                                <Row>
                                    Are you sure you want to archive transaction {transaction?.Id}?
                                </Row>
                                <br />
                                <Row>
                                    <Col className="d-flex justify-content-start">
                                        <Button onClick={() => onHide(false)} >Cancel</Button>
                                    </Col>
                                    <Col className="d-flex justify-content-end">
                                        <Button variant='danger' onClick={archiveClicked} className="me-2">
                                            Archive
                                        </Button>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </div>
                </Modal.Body>

            </Modal >
        </>
    );
};

export default ArchiveTransactionModal;